import { Input } from "@/components/ui/input";
import { ANIMAL_TYPES } from "@/lib/animalTypes";

export default function AnimalTypeSelector({ value, onChange, speciesOther, onSpeciesOtherChange, testIdPrefix = "animal-type" }) {
  return (
    <div>
      <div className="grid grid-cols-4 gap-2">
        {ANIMAL_TYPES.map((t) => (
          <button
            key={t}
            type="button"
            onClick={() => onChange(t)}
            data-testid={`${testIdPrefix}-${t.toLowerCase()}-toggle`}
            className={`h-11 rounded-xl border-2 text-sm font-semibold transition-colors ${
              value === t ? "border-amtm-teal bg-amtm-teal/15 text-amtm-teal" : "border-amtm-border text-amtm-textMuted"
            }`}
          >
            {t}
          </button>
        ))}
      </div>
      {value === "Other" && (
        <Input
          value={speciesOther}
          onChange={(e) => onSpeciesOtherChange(e.target.value)}
          placeholder="Specify species (e.g. Goose, Duck)"
          data-testid={`${testIdPrefix}-species-other-input`}
          className="mt-2 h-11"
        />
      )}
    </div>
  );
}
